// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2kkAf","col":"Table_col__MnSIF","fulfillmentStatus":"Table_fulfillmentStatus__1Batk","emailCol":"Table_emailCol__2MzVd"};